import { Button } from '@customerio/pluma-components/react';
import { BlankSlate } from '../../directory/components/blank-slate';

const WEBHOOKS_DOCS_URL = 'https://docs.customer.io/journeys/webhooks-action/';

/**
 * The Webhooks sub-tab (the `/integrations/all/webhooks` route body) — a static
 * blank slate pointing at the webhooks docs. The route is URL-only: it renders
 * inside the integrations shell but has no entry in the tab nav.
 */
export function WebhooksTab() {
  return (
    <BlankSlate
      icon="webhook"
      title="Connect Customer.io to almost any tool using webhooks."
      description="Webhooks let you to send and receive data, trigger automations, and more – all through a simple URL."
    >
      <Button
        href={WEBHOOKS_DOCS_URL}
        variant="primary"
        isExternal
        icon="exit"
        iconPosition="trailing"
        data-test-integrations-webhooks-docs-button
      >
        View documentation
      </Button>
    </BlankSlate>
  );
}
